<template>
  <div>
    <div class="pc-group-portrait">
      <BreadCrumb :data="breadCrumb" :title="'群体画像'" />
      <!-- <div class="overview">
        <div v-for="item in overViewData" :key="item.id" class="overview-item">
          <p class="item-icon" :style="{ backgroundColor: item.color }">
            <span class="iconfont icon-yonghu"></span>
          </p>
          <div class="item-data">
            <p class="name">{{ item.name }}</p>
            <p class="data" :style="{ color: item.color }">{{ item.data }}</p>
          </div>
        </div>
      </div> -->
      <div class="content" >
        <!-- <div class="spatial-analysis" v-if="1==2">
          <div class="content-head">
            <p class="content-title" >地域分析</p>
            <p>范围：</p>
            <el-select v-model="value" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <SpatialAnalysisEchart :selected="value" :spatialAnalysisData="spatialAnalysisData"/>
        </div> -->
        <div class="content-line">
          <div class="content-line-item">
            <div class="content-head">
              <p class="content-title">系统环境</p>
            </div>
            <SystemEnv :userData = userData />

          </div>
          <div class="content-line-item">
            <div class="content-head">
              <p class="content-title">年龄与性别分布</p>
            </div>
            <AgeAndSex :userData = userData />
          </div>
        </div>
        <div class="content-line"  v-if="1==2">
          <div class="content-line-item">
            <div class="content-head">
              <p class="content-title">近7天新增用户情况</p>
            </div>
            <NewUsers :newUsers = newUsers />
          </div>
          <div class="content-line-item" v-if="1==2">
            <div class="content-head">
              <p class="content-title">近7天用户活跃度</p>
            </div>
            <UserActiveRatio :userActive="userActive"/>
          </div>
        </div>
        <div class="content-line">
          <div class="content-line-item">
            <div class="content-head">
              <p class="content-title">职业分布</p>
            </div>
            <OccupationDistribution :userData= userData />
          </div>
          <div class="content-line-item">
            <div class="content-head">
              <p class="content-title">检索关键词热度</p>
            </div>
            <KeyWordsHot :userData= userData />
          </div>
        </div>
        <div class="page-relationship" v-if="1==2">
          <div class="content-head">
            <p class="content-title">近30天页面访问关系图</p>
          </div>
          <ViewRelationship :relationshipData="relationshipData" />
        </div>
      </div>
    </div>
    <p></p>
  </div>
</template>

<script>
import {getUserData_Api} from "../../../apis/user.api"
import BreadCrumb from "../../componentSet/BreadCrumb";
import SpatialAnalysisEchart from "./groupPortrait/SpatialAnalysisEchart";
import NewUsers from './groupPortrait/NewUsers'
import SystemEnv from  './groupPortrait/SystemEnv'
import KeyWordsHot from './groupPortrait/KeyWordsHot'
import UserActiveRatio from './groupPortrait/UserActiveRatio'
import AgeAndSex from './groupPortrait/AgeAndSex'
import OccupationDistribution from './groupPortrait/OccupationDistribution'
import ViewRelationship from './groupPortrait/ViewRelationship'
export default {
  data() {
    return {
      userData:{},

      systemEnv:{},
      spatialAnalysisData:null,
      genderData:null,
      ageData:null,
      occupationData:null,
      keyWordsData:null,
      newUsers:[],
      relationshipData:null,
      userActive:{},

      // UserStatisticsesArgs:{
      // },
      options: [
        {
          value: "全球",
          label: "全球",
        },
        {
          value: "国内",
          label: "国内",
        },
      ],
      value: "全球",
      overViewData: [
        { name: "用户总数", color: "#5470C6", data: null },
        { name: "活跃用户数  占比", color: "#FAC858", data: null },
        { name: "新用户数", color: "#91CC75", data: null },
        // { name: "活跃用户比例", color: "#EE6666", data: null },
      ],
      breadCrumb: [
        { name: "用户管理", link: "/admin/userlist" },
        { name: "群体画像", link: "/admin/groupPortrait" },
      ],
    };
  },
  components: {
    OccupationDistribution,
    ViewRelationship,
    KeyWordsHot,
    NewUsers,
    UserActiveRatio,
    SystemEnv ,
    AgeAndSex,
    BreadCrumb,
    SpatialAnalysisEchart,
  },
   async created() {
     this.getUserData()
    //  await this.getUserPortraits()
    //  await this.getUserTotal()
    //  await this.getDailyStatisticses()
    //  await this.getUserStatisticses()
    //  await this.getUserActive()
  },
  methods: {
    getUserData(){
      getUserData_Api().then((res)=>{
        this.userData= res
        console.log(res)
      })
    },
  },
};
</script>

<style  scoped lang="scss">
.pc-group-portrait {
  .overview {
    display: flex;
    margin-top: 40px;
    justify-content: space-between;
    box-shadow: $shadow;
    padding: 27px 0px;
    .overview-item {
      display: flex;
      align-items: center;
      width: 25%;
      height: 87px;
      border-right: $border;
      padding-left: 4%;

      .item-icon {
        height: 80px;
        width: 80px;
        flex-shrink: 0;
        text-align: center;
        border-radius: 8px;
        margin-right: 40px;
        .iconfont {
          line-height: 80px;

          font-size: 50px;
          color: $base-color;
        }
      }
      .item-data {
        flex-shrink: 0;
        .name {
          font-size: 14px;
        }
        .data {
          font-size: 40px;
          font-weight: 600;
        }
      }
    }
    .overview-item:last-child {
      border: none;
    }
  }
  .content {
    .content-head {
      display: flex;
      align-items: center;
      height: 90px;
      border-bottom: $border;
      .content-title {
        margin-right: 50px;
        font-weight: 600;
      }
    }

    .spatial-analysis,
    .page-relationship {
      margin-top: 40px;
      height: 840px;
      box-shadow: $shadow;
      padding: 0px 30px;
    }
    .page-relationship{
      height: 780px;
    }

    .content-line {
      display: flex;
      margin-top: 40px;
      .content-line-item {
        width: 49%;
        padding: 0px 30px;
        box-shadow: $shadow;
        height: 500px;
      }
      .content-line-item:nth-of-type(odd) {
        margin-right: 2%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/GroupPortrait.vue